<template>
  <div id="scroll-div-three-d" class="main layer2" style="height: calc(100% - 2.5rem); padding-top: 2.5rem; overflow: auto;">
    <swiper :ad-list="adList"></swiper>
    <books-small :show-title="false" :books="books.small"></books-small>
    <books-large :show-title="false" :books="books.large"></books-large>
    <loading ref="loading" scroll-div="scroll-div-three-d" :is-loading="isLoading" :is-no-more-data="isNoMoreData" @get-books="getBooks(currentPage + 1)"></loading>
  </div>
</template>

<script>
  import Swiper from '@/components/share/swiper'
  import BooksSmall from '@/components/share/books-small'
  import BooksLarge from '@/components/share/books-large'
  import Loading from "../../../components/share/loading";

  import listService from "../../../services/listService";

  export default {
    name: 'three-d',
    data() {
      return {
        componentName: '',
        adList: [],
        books: {
          small: [],
          large: []
        },
        isLoading: false,
        isNoMoreData: false,
        currentPage: 1
      }
    },
    methods: {
      getBooks(target) {
        this.currentPage = target;
        if(target === 1) {
          this.books = {small: [], large: []}
        }
        this.isLoading = true;
        this.isNoMoreData = false;
        listService.getMoreThreeD(target)
          .then(res => {
            this.isLoading = false;
            this.adList = res.data.adList;
            if (res.data.totalPage === 0) {
              this.isNoMoreData = true;
              this.books = {small: [], large: []}
            } else if (this.currentPage === 1) {
              let data = res.data.bookList;
              this.books.small = data.splice(0, 3);
              this.books.large = data;
            } else if (this.currentPage > 1 && this.currentPage <= res.data.totalPage) {
              this.books.large.push(...res.data.bookList);
            }
            if (res.data.totalPage == 0 || this.currentPage >= res.data.totalPage) {
              this.isNoMoreData = true;
            }
            setTimeout(() => {
              this.$refs['loading'].scrollFunction();
            }, 0)
          })
      }
    },
    components: {
      swiper: Swiper,
      'books-small': BooksSmall,
      'books-large': BooksLarge,
      loading: Loading
    },
    mounted() {
      this.componentName = this.$route.name;
      console.log(this.componentName, this.$store.state.pageState[this.componentName]);
      if(this.$store.state.pageState[this.componentName] && this.$router.isBack) {
        Object.assign(this.$data, this.$store.state.pageState[this.$route.name].data);
        setTimeout(() => {
          let scrollDiv = document.getElementById('scroll-div-three-d');
          scrollDiv.scrollTop = this.$store.state.pageState[this.$route.name].top;
        }, 5);
      }
      else {
        this.getBooks(1);
      }
      this.$router.isBack = true;
    },
    beforeDestroy() {
      let scrollDiv = document.getElementById('scroll-div-three-d');
      let state = {};
      state[this.componentName] = {data: this.$data, top: scrollDiv.scrollTop}
      this.$store.commit('saveState', state);
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/layer2/books/three-d.vue